// In-guide screenshots live in docs/images/ — the single committed source of
// truth, which GitHub also renders natively from a relative `images/...` link.
// At dev/build time scripts/copy-help-images.mjs copies them to the web app's
// served public/help-images/ directory. A markdown image written in a guide as
// `images/foo.png` (relative to docs/), or `../images/foo.png` from a
// quick-reference card under docs/quick-reference/, is rewritten here to the
// same-origin `/help-images/foo.png` the app actually serves — so the SAME
// relative path works both on GitHub and inside the in-app Help Centre.

/** Root path Vite serves the copied screenshots from (public/help-images/). */
export const HELP_IMAGE_SERVED_PREFIX = '/help-images/';

// The tail after an `images/` path segment — the flat filename, since every
// screenshot lives directly in docs/images/ with a unique basename.
const IMAGES_SEGMENT = /(?:^|\/)images\/(.+)$/;

/** Rewrites a guide's relative `images/…` markdown image src to the served
 * `/help-images/…` path. Absolute URLs (`https://…`) and already-rooted paths
 * (`/…`, including anything already under the served prefix) pass through
 * unchanged, as does any src that does not sit under an `images/` segment. */
export function resolveHelpImageSrc(src: string | undefined): string | undefined {
  if (!src) return src;
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(src) || src.startsWith('/')) return src;
  const match = IMAGES_SEGMENT.exec(src);
  return match ? `${HELP_IMAGE_SERVED_PREFIX}${match[1]}` : src;
}
